import { compact } from 'lodash';
import { Node_Type } from 'ricos-types';
import { TOOLBARS, INSERT_PLUGIN_BUTTONS, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { videoModals } from './constants.js';
import { RICOS_DEFAULTS } from './defaults.js';
import { InsertModal } from './modals/InsertModal.js';
import { videoButtonsTypes } from './types.js';
import InsertPluginIcon from './icons/VideoInsertPluginIcon.js';
import YoutubeIcon from './icons/YoutubeIcon.js';
import 'ricos-schema';
import '@wix/design-system';
import 'react';
import 'ricos-context';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import './embed-video-91705df7.js';
import 'ricos-content';
import 'wix-react-player';
import './style-inject.es-e7b07dd7.js';
import './dataHooks.js';
import './toolbar/is-video-metadata.js';
import './toolbar/upload-video.js';
import 'ricos-schema/dist/statics/video.defaults.json';
import 'wix-rich-content-plugin-commons';
import './toolbar/videoPluginService.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const toolbarsToAddIn = [
  TOOLBARS.FOOTER,
  TOOLBARS.SIDE,
  TOOLBARS.MOBILE
];
const getAddButtons = (config) => {
  const {
    disableDownloadDefault,
    enableCustomUploadOnMobile,
    getVideoUrl,
    exposeButtons = [videoButtonsTypes.video],
    handleFileSelection,
    handleFileUpload,
    disableDownload,
    onVideoSelected
  } = config || {};
  const modalBaseProps = {
    disableDownloadDefault,
    enableCustomUploadOnMobile,
    getVideoUrl,
    handleFileSelection,
    handleFileUpload,
    onVideoSelected
  };
  const buttonsMap = {
    [videoButtonsTypes.video]: {
      id: `${Node_Type.VIDEO}.video`,
      label: INSERT_PLUGIN_BUTTONS.VIDEO,
      dataHook: INSERT_PLUGIN_BUTTONS.VIDEO,
      icon: InsertPluginIcon,
      tooltip: "VideoPlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: () => true,
      modal: {
        id: videoModals.insertVideo,
        Component: decorateComponentWithProps(InsertModal, __spreadValues({
          componentData: __spreadProps(__spreadValues({}, RICOS_DEFAULTS), { disableDownload }),
          modalId: videoModals.insertVideo
        }, modalBaseProps)),
        noPadding: true
      },
      menuConfig: {
        tags: "Video_plugin_search_tags"
      }
    },
    [videoButtonsTypes.youTube]: {
      id: `${Node_Type.VIDEO}.youTube`,
      label: INSERT_PLUGIN_BUTTONS.YOUTUBE,
      dataHook: INSERT_PLUGIN_BUTTONS.YOUTUBE,
      icon: YoutubeIcon,
      tooltip: "YouTubePlugin_InsertButton_Tooltip",
      toolbars: toolbarsToAddIn,
      command: () => true,
      modal: {
        id: videoModals.insertYoutube,
        Component: decorateComponentWithProps(InsertModal, __spreadValues({
          componentData: __spreadProps(__spreadValues({}, RICOS_DEFAULTS), { type: videoButtonsTypes.youTube }),
          modalId: videoModals.insertYoutube
        }, modalBaseProps)),
        noPadding: true
      },
      menuConfig: {
        tags: "YouTube_plugin_search_tags",
        group: "embed"
      }
    }
  };
  return compact(exposeButtons.map((buttonType) => buttonsMap[buttonType]));
};

export { getAddButtons, toolbarsToAddIn };
//# sourceMappingURL=getAddButtons.js.map
